import { Grid, Paper } from "@mui/material"
import { Title } from "components/Common/Title"
import { CreateUserGroupDialog } from "components/UserGroup/CreateUserGroupDialog"
import { UserGroupList } from "components/UserGroup/UserGroupList"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import organizationService from "services/organizationService"
import userGroupService from "services/userGroupService"
import userService from "services/userService"
import { setCurrentOrganization } from "slices/organizationSlice"
import { setUserGroups } from "slices/userGroupSlice"
import { setUsers } from "slices/usersSlice"

export function OrganizationUserGroups() {
  const { id } = useParams()
  const dispatch = useAppDispatch()

  const currentOrganization = useAppSelector((state) => state.organization.currentOrganization)
  const users = useAppSelector((state) => state.users.users)
  const userGroups = useAppSelector((state) => state.usergroup.userGroups)

  useEffect(() => {
    if (currentOrganization === undefined && id) {
      organizationService
        .getOrganization(id)
        .then((organization) => {
          dispatch(setCurrentOrganization(organization))
        })
        .catch((err) => {
          console.log(err)
        })
    }

    if (users.length < 1 && id) {
      userService
        .getOrganizationUsers(id)
        .then((users) => {
          dispatch(setUsers(users))
        })
        .catch((err) => {
          console.log(err)
        })
    }

    if (userGroups.length < 1 && id) {
      userGroupService
        .getOrganizationUserGroups(id)
        .then((userGroups) => {
          dispatch(setUserGroups(userGroups))
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [currentOrganization, dispatch, id, userGroups.length, users.length])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid container paddingBottom={2}>
            <Grid item xs>
              <Title>USER GROUPS</Title>
            </Grid>
            <Grid item>
              <CreateUserGroupDialog />
            </Grid>
            <Grid item></Grid>
          </Grid>
          <UserGroupList />
        </Paper>
      </Grid>
    </Grid>
  )
}
